import React, { useState, useMemo } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {
  BrowserRouter,
  Routes,
  Route,
} from 'react-router-dom';
import App from './components/App';
import Game from './components/Game';
import { Artist1Context, Artist2Context } from './context';

function RenderApp() {
  const [firstArtist, setFirstArtist] = useState(null);
  const [secondArtist, setSecondArtist] = useState(null);
  return (
    <Artist1Context.Provider
      value={useMemo(
        () => [firstArtist, setFirstArtist],
        [firstArtist, setFirstArtist],
      )}
    >
      <Artist2Context.Provider
        value={useMemo(
          () => [secondArtist, setSecondArtist],
          [secondArtist, setSecondArtist],
        )}
      >
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/game" element={<Game />} />
          </Routes>
        </BrowserRouter>
      </Artist2Context.Provider>
    </Artist1Context.Provider>
  );
}
ReactDOM.render(
  <RenderApp />,
  document.getElementById('root'),
);
